import { Component, Input, OnInit, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, Validators, FormGroup, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { JobDatesComponent } from 'src/app/jobs/job-dates/job-dates.component';
import { LabourJobService } from './../labour-job.service';
import { UtilityService } from './../../services/utility.service';
import { StaffService } from './../../services/staff/staff.service';
import { FilterService } from '../../services/filter.service';
import { ClientService } from '../../services/client.service';
import { CompetenciesService } from '../../services/competencies.service';
import { MapsService } from '../../services/maps.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { CurrencyPipe } from '@angular/common';
import { saveAs } from "file-saver";
declare var what3words: any;



@Component({
  selector: 'labour-job-create-edit',
  templateUrl: './labour-job-create-edit.component.html',
  styleUrls: ['./labour-job-create-edit.component.scss']
})
export class LabourJobCreateEditComponent implements OnInit {

  @Input('jobDetail') labourjobDetail
  @Input('allJobsData') jobrequiredData
  labourjobForm: FormGroup
  isMapEdit = false
  isEdit = false
  latitude: number;
  longitude: number;
  address: any;
  duration
  startingDate
  endingDate
  singleJobDate = [];
  totalDays = [];
  isDisabled = false
  singleJobDetail
  color
  isjobdateChange = false
  competencyList = []
  competencyListCopy = []
  staffUserList = []
  staffUserListCopy = []
  user
  isMapJob = true
  @ViewChild(JobDatesComponent, { static: false }) jobDateComp: JobDatesComponent;
  tempDateArray = [];
  totalTime
  totalHoursWorked = { hours: 0, minutes: 0 };
  displayHours = "00:00"
  loading = false
  isSubmit = false
  what3words = {}
  totalChargeRate = 0
  totalPayRate = 0
  totalProfit = 0
  jobList = []
  isDownload = false
  clientList = []
  searchText: string
  assetCategoryList = []
  isAdd = true
  isComp = true
  listofJobData
  isdisablePOnum = true
  jobOperativeList = []
  allJobs = []
  existingUserData = []
  startTime
  endTime
  isSchedule = false
  constructor(
    public formBuilder: FormBuilder,
    private _router: Router,
    public _labourjobService: LabourJobService,
    public _cd: ChangeDetectorRef,
    public _utilityService: UtilityService,
    public _filter: FilterService,
    public _staffService: StaffService,
    public currencyPipe: CurrencyPipe,
    public _clientService: ClientService,
    public _competencyService: CompetenciesService,
    public _mapService: MapsService
  ) { }

  ngOnInit(): void {
    this.filteronCompetency()
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this._router.url.includes('/create')) {
      this.createForm();
      // this.getRequiredjobData()
    }
    if (this.user && this.user.isOperative) this.isDisabled = true, this.isMapJob = false
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES OF LABOUR JOB DETAILS", changes);
    if (changes.jobrequiredData && changes.jobrequiredData.currentValue) {
      this.listofJobData = changes.jobrequiredData.currentValue
      this.clientList = this.listofJobData.clients
      this.jobList = this.listofJobData.jobs
      this.staffUserList = this.listofJobData.staff
      this.staffUserListCopy = this.listofJobData.staff
      this.assetCategoryList = this.listofJobData.assetList
    }
    if (changes.labourjobDetail && changes.labourjobDetail.currentValue) {
      this.singleJobDetail = changes.labourjobDetail.currentValue
      this.createForm(this.singleJobDetail)
      if (this.singleJobDetail && this.singleJobDetail.startDate) this.startingDate = this.singleJobDetail.startDate
      this.totalDays = this.singleJobDetail.totalDays
      if (this.singleJobDetail && this.singleJobDetail.endDate) this.endingDate = this.singleJobDetail.endDate
      // this.color = this.singleJobDetail.jobColor 
      this.longitude = this.singleJobDetail && this.singleJobDetail.jobLocation ? this.singleJobDetail.jobLocation._id.locationGeometry.coordinates[0] : ''
      this.latitude = this.singleJobDetail && this.singleJobDetail.jobLocation ? this.singleJobDetail.jobLocation._id.locationGeometry.coordinates[1] : ''
      this.what3words = this.singleJobDetail && this.singleJobDetail.jobLocation ? this.singleJobDetail.jobLocation.what3words : ''
      console.log("SINGLE JOB DETAILS WHEN OTHER DATA LOAD", this.singleJobDetail, this.longitude, this.latitude);
      if (this.longitude || this.latitude) this.isMapEdit = true
      else this.isMapEdit = false
      // this.isMapEdit = true
      // this.singleJobDate = this.singleJobDetail.singleJobDate
      this.totalHoursWorked = this.singleJobDetail.plannedhours
      if (this.singleJobDetail.startDate != '' && this.singleJobDetail.endDate != '' && this.singleJobDetail.startTime != '' && this.singleJobDetail.endTime != '') {
        this.isSchedule = true
      }
      // _.forEach(this.singleJobDate, (oneDate) => {
      //   this.tempDateArray.push(oneDate)
      // })
      // console.log("WHAT IS TEMP DATE ARRAY", this.tempDateArray, this.singleJobDate, this.singleJobDetail);

      // if (this.singleJobDate && !this.singleJobDate.length) this.tempDateArray = []
      this.duration = this.calculateDuration(this.startingDate, this.endingDate)
      this.isEdit = true
      if (this._router.url.includes('/client/view')) {
        this.createForm(this.singleJobDetail)
      }
      if (this.singleJobDetail != undefined && this.listofJobData != undefined) this.createForm(this.singleJobDetail)
    }


  }

  // FORM CONTROL

  /**
  * Form group for create or edit labour job with required details
  */
  createForm(data?) {
    console.log("DATA WHILE EDIT JOB", data);
    this.labourjobForm = this.formBuilder.group({
      jobTitle: new FormControl({ value: (data && data.jobTitle) ? data.jobTitle : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      // jobColor: new FormControl({ value: (data && data.jobColor) ? data.jobColor : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      // ponumber: new FormControl({ value: (data && data.ponumber) ? data.ponumber : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      ponumber: this.formBuilder.array(this.multiplePOnumber((data && data.ponumber) ? data.ponumber : [])),
      startDate: new FormControl({ value: (data && data.startDate) ? data.startDate : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      endDate: new FormControl({ value: (data && data.endDate) ? data.endDate : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      startTime: new FormControl({ value: (data && data.startTime) ? data.startTime : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      endTime: new FormControl({ value: (data && data.endTime) ? data.endTime : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
      travelTime: new FormControl({ value: (data && data.travelTime) ? data.travelTime : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      jobLocation: new FormControl({ value: (data && data.jobLocation) ? data.jobLocation.title : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      locationType: new FormControl('labourjob'),
      coordinates: new FormControl({ value: (data && data.jobLocation) ? data.jobLocation._id.locationGeometry.coordinates : [], disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      address: this.formBuilder.array(this.addresList((data && data.jobLocation) ? data.jobLocation._id.address : [])),
      what3words: new FormControl({ value: (data && data.jobLocation) ? data.jobLocation._id.what3words : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      operatives: this.formBuilder.array(this.multipleOperative(data && data.operatives && data.operatives.length ? data.operatives : [])),
      plannedhours: new FormControl({ value: (data && data.plannedhours) ? data.plannedhours : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
      clients: this.formBuilder.array(this.multipleClients((data && data.clients && data.clients.length) ? data.clients : [])),
      linkedAssets: this.formBuilder.array(this.multipleAssets((data && data.linkedAsset && data.linkedAsset.length) ? data.linkedAsset : [])),
    })
    this.changeFormvalue()
    if (data && data.ponumber && data.ponumber.length) this.disablePOnumber(this.labourjobForm.controls.ponumber.value)
    if (data && data.operatives && data.operatives.length) this.calculateAmount(this.labourjobForm.controls.operatives.value)
    console.log("THIS IS THE FORM DATA", this.labourjobForm.value);
  }

  changeFormvalue() {
    this.labourjobForm.valueChanges.subscribe(value => {
      console.log("AFTER VALUE ASSIGN TO FORM CONTROL", value);
      if (value.startDate != '' && value.endDate != '' && value.startTime != '' && value.endTime != '') {
        let startTime = moment(value.startTime, 'HH:mm:ss a').valueOf();
        let endTime = moment(value.endTime, 'HH:mm:ss a').valueOf();
        this.startTime = value.startTime
        this.endTime = value.endTime
        this.totalTime = this.calculateTime(value.startTime, value.endTime, value.startDate)
        if (this.singleJobDate && this.singleJobDate.length) {
          this.singleJobDate = this.singleJobDate.filter((x) => x.totalhours = this.totalTime)
          this.calculatePlannedhours()
        }
        this.isSchedule = true
        // this.emptyFrequencyDates()
        // this.verifyUsersList()
      }
      if (value.operatives && value.operatives.length) {
        this.calculateAmount(value.operatives)
        value.operatives.filter((x) => {
          if (x.operatives !== '') {
            console.log("VALUE OF OPERATIVE", x)
            let element = this.jobOperativeList.findIndex((y) => y.userId._id === x.operatives.userId._id)
            if (element == -1) this.jobOperativeList.push(x.operatives)
          }
        })
      }
      if (value.linkedAssets && value.linkedAssets.length) this.disableAssets()
      if (value.ponumber) this.disablePOnumber(value.ponumber)
    });
  }


  get multipleAssetcategoryGroup() { return <FormArray>this.labourjobForm.get('linkedAssets') }

  multipleAssets(assets) {
    let assetList = []
    if (assets && assets.length) {
      _.forEach(assets, async (user) => {
        console.log("SINGLE CLIENT DATA", user, this.clientList);
        let index = this.clientList.findIndex((x) => x._id == user.client._id)
        if (index != -1) this.clientList[index]['isSelected'] = true
        await assetList.push(new FormGroup({
          client: new FormControl({ value: (user && user.client) ? user.client : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
        }))
      })
      // console.log("THIS IS THE CLIENTS LIST TO BE DISPLAY",assetList , this.assetList);
      return assetList;
    } else {
      return [this.formBuilder.group({
        assetCategory: new FormControl(''),
        assetList: new FormControl([]),
        selectedAsset: new FormControl(''),
        assignOperative: new FormControl([]),
        linkedAsset: new FormControl([]),
        operativeList: new FormControl(this.jobOperativeList)
      })]
    }
  }


  addMultipleAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.push(this.formBuilder.group({
      assetCategory: new FormControl(''),
      assetList: new FormControl([]),
      selectedAsset: new FormControl(''),
      assignOperative: new FormControl([]),
      operativeList: new FormControl(this.jobOperativeList),
      linkedAsset: new FormControl([])
    }))
  }


  deleteAssets(item, index) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.removeAt(index)
  }


  disableAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    let selectedAsset = control.value
    let lastElement = selectedAsset[selectedAsset.length - 1]
    // console.log("THIS IS THE LAST ELEMENT", lastElement);
    if (lastElement.assetCategory != '') this.isAdd = false
    else this.isAdd = true
  }



  assetCategorySelect(item, i) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    const currentCategory = item.value
    const currentFormdata = this.labourjobForm.controls.linkedAssets.value
    const mainAssetList = this.assetCategoryList.find((x) => x._id === currentCategory.assetCategory._id)
    const categoryData = currentFormdata.filter((x) => x.assetCategory._id === currentCategory.assetCategory._id)
    let assetList = []
    const allAssetList = mainAssetList.assetList
    const assetLength = allAssetList.length
    for (let i = 0; i < assetLength; i++) {
      const elemenet = currentFormdata.find((x) => x.selectedAsset._id === allAssetList[i]._id)
      console.log("SINGLE ELEMENT", elemenet)
      let isExits
      if (elemenet == undefined) {
        isExits = this.verifyAssetDate(allAssetList[i])
        allAssetList[i]['isSelected'] = isExits
      } else {
        allAssetList[i]['isSelected'] = true
      }
      assetList.push(allAssetList[i])
    }
    console.log("AFTER PUSH THE DATA", assetList)
    control.at(i).patchValue({ assetList: assetList })
  }

  // Here verify asset data with previous jobs or future jobs linked assets date
  // If asset is used in another job then that asset is not select in current job
  verifyAssetDate(asset) {
    const jobLength = this.allJobs.length
    let isEnd
    let isStart
    for (let i = 0; i < jobLength; i++) {
      const assetAvalible = this.allJobs[i].linkedAssets.filter((x) => x.selectedAsset._id === asset._id)
      if (assetAvalible && assetAvalible.length) {
        for (let j = 0; j < assetAvalible.length; j++) {
          const currentStartDate = this.labourjobForm.value.startDate
          const currentEndDate = this.labourjobForm.value.endDate
          const existingStartDate = this.allJobs[i].startDate
          const existingEndDate = this.allJobs[i].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          // isStart = this.checkDate(currentStartDate, currentEndDate, existingStartDate)
          // isEnd = this.checkDate(currentStartDate, currentEndDate, existingEndDate)
          console.log("VALUE OF DATE EXITS", isStart, isEnd, asset.title)
          if (isStart || isEnd) break;
        }
      }
      else {
        isStart = false
        isEnd = false
      }
      if (isStart || isEnd) break;
    }
    if (!isStart && !isEnd) return false
    else return true
  }


  assetSelection(event, item, index) {
    // console.log("THIS IS THE EVENT", index)
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    let selectedAsset = item.value.selectedAsset
    let linkedAssetList = selectedAsset.linkedAsset
    const linkedAssetLength = linkedAssetList.length
    const otherjobsLinkedAsset = this.getOtherjobLinkedAsset(item)
    for (let i = 0; i < linkedAssetLength; i++) {
      console.log("OTHER JOBS LINKED ASSET LIST", otherjobsLinkedAsset, linkedAssetList[i])
      const currentAsset = otherjobsLinkedAsset.filter((x) => x._id === linkedAssetList[i]._id)
      console.log("CURRENT ASSET DATA", currentAsset)
      let isEnd
      let isStart
      if (currentAsset && currentAsset.length) {
        for (let j = 0; j < currentAsset.length; j++) {
          const currentStartDate = this.labourjobForm.value.startDate
          const currentEndDate = this.labourjobForm.value.endDate
          const existingStartDate = currentAsset[j].startDate
          const existingEndDate = currentAsset[j].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          // console.log("VALUE OF DATE EXITS", isStart, isEnd, asset.title)
          if (isStart || isEnd) break;
        }
        console.log("VERIFYING DATA OF SUB ASSET", linkedAssetList[i].title, isStart, isEnd)
        if (isStart || isEnd) linkedAssetList[i]['isSelected'] = true
        else linkedAssetList[i]['isSelected'] = false
      } else {
        linkedAssetList[i]['isSelected'] = false
        // isStart = false
        // isEnd = false
      }
      // if (isStart || isEnd) break;
    }
    selectedAsset['linkedAsset'] = linkedAssetList
    console.log("ITEM OF CURRENT Asset CAtegory with asset", selectedAsset)
    control.at(index).patchValue({ selectedAsset: selectedAsset })
  }

  getOtherjobLinkedAsset(asset) {
    const jobLength = this.allJobs.length
    let linkedAsset = []
    for (let i = 0; i < jobLength; i++) {
      // console.log("SINGLE JOB DETAILS", this.allJobs[j])
      const singleJob = this.allJobs[i]
      if (singleJob.linkedAssets && singleJob.linkedAssets.length) {
        const assetList = singleJob.linkedAssets
        const assetLength = assetList.length
        for (let j = 0; j < assetLength; j++) {
          assetList[j].linkedAsset = assetList[j].linkedAsset.map((x) => {
            x['startDate'] = singleJob.startDate,
              x['endDate'] = singleJob.endDate
            return x
          })
          // console.log("ASSET LIST with changes", assetList[j])
          linkedAsset = linkedAsset.concat(assetList[j].linkedAsset)
        }
      }
    }
    console.log("Curren Asset data", asset)
    const currentjobAssets = this.labourjobForm.value
    if (currentjobAssets.linkedAssets && currentjobAssets.linkedAssets.length) {
      const currentLinkedAssets = currentjobAssets.linkedAssets
      console.log("CURRENT FORM VALUE", currentjobAssets.linkedAssets)
      for (let k = 0; k < currentLinkedAssets.length; k++) {
        if (currentLinkedAssets[k].selectedAsset._id !== asset.value.selectedAsset._id) {
          currentLinkedAssets[k].linkedAsset = currentLinkedAssets[k].linkedAsset.map((x) => {
            x['startDate'] = currentjobAssets.startDate
            x['endDate'] = currentjobAssets.endDate
            return x
          })
          linkedAsset = linkedAsset.concat(currentLinkedAssets[k].linkedAsset)
        }
      }
    }
    return linkedAsset
  }


  get multipleClientsGroup() { return <FormArray>this.labourjobForm.get('clients') }
  multipleClients(clients) {
    let clientList = []
    if (clients && clients.length) {
      _.forEach(clients, async (user) => {
        console.log("SINGLE CLIENT DATA", user, this.clientList);
        let index = this.clientList.findIndex((x) => x._id == user.client._id)
        if (index != -1) this.clientList[index]['isSelected'] = true
        await clientList.push(new FormGroup({
          client: new FormControl({ value: (user && user.client) ? user.client : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }, Validators.required),
          projectCode: new FormControl({ value: (user && user.projectCode) ? user.projectCode : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
        }))
      })
      console.log("THIS IS THE CLIENTS LIST TO BE DISPLAY", clientList, this.clientList);
      return clientList;
    } else {
      return [this.formBuilder.group({
        client: new FormControl('', Validators.required),
        projectCode: new FormControl(''),
      })]
    }
  }





  AddMultipleClients() {
    const control = <FormArray>this.labourjobForm.controls.clients
    control.push(this.formBuilder.group({
      client: new FormControl('', Validators.required),
      projectCode: new FormControl(''),
    }))

  }

  deleteClient(index, item) {
    console.log("THIS IS THE ITEM VALUE", item);

    const control = <FormArray>this.labourjobForm.controls.clients
    console.log("CONTROL VALUE", control);
    control.removeAt(index)
    let clientindex = this.clientList.findIndex((x) => x._id == item.value.client._id)
    if (clientindex != -1) this.clientList[clientindex]['isSelected'] = false
  }

  clientChanged(event, item) {
    console.log("THIS IS EVENT", event);
    console.log("ITEM", item);
    const control = <FormArray>this.labourjobForm.controls.clients
    console.log("CONTROL VALUE", control);

    this.clientList = this.clientList.filter((x) => {
      let index = control.value.findIndex((y) => y.client._id == x._id)
      console.log("VALUE OF INDEX", index);

      if (index != -1) x['isSelected'] = true
      else x['isSelected'] = false
      return x
    })
  }

  compareProjectcode(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  calculateTime(startTime, endTime, calDate) {
    console.log("CALCULATE TOTAL TIME", startTime, endTime, calDate)
    let minutes
    let hours
    let startHours = startTime.split(":")[0]
    let startMinutes = startTime.split(":")[1]
    let endHours = endTime.split(":")[0]
    let endMinutes = endTime.split(":")[1]
    let time1: any
    let time2: any
    let difference
    let date = moment(calDate)
    if (endHours >= startHours && endHours <= 23) {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      time2 = new Date(date.toDate().setHours(endHours, endMinutes));
    } else {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      let tempDate = moment(date, "MM-DD-YYYY").add(1, "days")
      time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
    }
    difference = (time2 - time1) / 60000;
    if (difference < 0) return ({ hours: 0, minutes: 0 })
    else
      minutes = difference % 60;
    hours = (difference - minutes) / 60;
    return hours + ":" + minutes
  }


  get multipleOperativeGroup() { return <FormArray>this.labourjobForm.get('operatives') }

  multipleOperative(operativeList?): Array<any> {
    let operativeUsers = [];
    if (operativeList && operativeList.length) {
      _.forEach(operativeList, async (user, index) => {
        console.log("SINGLE COMPETENCY DATA", user, index);
        await operativeUsers.push(new FormGroup({
          competency: new FormControl({ value: user && user.competency ? user.competency : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
          operatives: new FormControl({ value: user.operatives && user.operatives != '' ? user.operatives : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
          chargeRate: new FormControl({ value: user && user.chargeRate ? user.chargeRate : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
          payRate: new FormControl({ value: user && user.payRate ? user.payRate : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
          averageFatigueScore: new FormControl(user && user.averageFatigueScore ? user.averageFatigueScore : ''),
          averageRiskScore: new FormControl(user && user.averageRiskScore ? user.averageRiskScore : ''),
          competencyList: new FormControl(this.competenylistedit(user, index)),
          // operativeList: new FormControl(user.operatives && user.operatives != '' ? this.getOperatives(user.competency, user.operatives) : []),
          operativeList: new FormControl(this.getOperatives(user.competency, user.operatives)),
          frequencyDays: new FormControl(user && user.frequencyDays ? user.frequencyDays : []),
          frequencyDates: new FormControl(user && user.frequencyDates ? user.frequencyDates : []),
          plannedTravelTime: new FormControl(user && user.plannedTravelTime ? user.plannedTravelTime : '')
        }))
      })
      return operativeUsers;
    } else {
      return [this.formBuilder.group({
        competency: new FormControl({ value: '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
        operatives: new FormControl({ value: '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
        chargeRate: new FormControl(''),
        payRate: new FormControl(''),
        averageFatigueScore: new FormControl(''),
        averageRiskScore: new FormControl(''),
        competencyList: new FormControl(this.competencyList),
        operativeList: new FormControl(''),
        frequencyDays: new FormControl([]),
        frequencyDates: new FormControl([]),
        plannedTravelTime: new FormControl('')
      })]
    }
  }

  getOperatives(comptency, users) {

    let competencyList = comptency
    let existingUsers = []
    let existingCompeteny = this.singleJobDetail.operatives.filter((x) => {
      let temp = x.competency.filter((y) => competencyList.find((z) => z.alias == y.alias))
      if (temp && temp.length) return x
    })
    console.log("THIS IS EXISTING COMPETENCY LIST", existingCompeteny);
    if (existingCompeteny && existingCompeteny.length) {
      existingCompeteny.filter((x) => {
        if (x.operatives && x.operatives != '') existingUsers.push(x.operatives)
      })
    }

    let list = []
    let userLength = this.staffUserListCopy.length
    console.log("SINGLE USER DATA", userLength);

    for (let i = 0; i < userLength; i++) {
      let x = this.staffUserListCopy[i]
      let user = x.competencies.filter((y) => competencyList.find((z) => z.alias == y.alias))
      if (user && user.length) list.push(x)
    }
    let finalUserList = []
    console.log("EXISTING USERS DATA", existingUsers)
    list.filter((x) => {
      let temp = existingUsers.find((y) => y._id === x._id)
      if (temp == undefined) finalUserList.push(x)
      if (temp != undefined && temp._id === users._id) finalUserList.push(x)

    })
    console.log("COMPETENCY LIST TO BE CHECKED", list, finalUserList);
    return finalUserList;
  }


  // Get address list from formgroup
  getAddressList() {
    return this.labourjobForm.get('address') as FormArray;
  }

  // Generate formarray for address list
  addresList(address) {
    if (address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl({ value: (singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title, disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl('')
      })]
    }
  }

  // Get address list from formgroup
  get getPOlist() { return this.labourjobForm.get('ponumber') as FormArray; }


  multiplePOnumber(poList) {
    console.log("LIST OF PO NUMBER", poList)
    if (poList && poList.length) {
      let poListdata = []
      _.forEach(poList, async (singlePO) => {
        await poListdata.push(new FormGroup({
          potext: new FormControl({ value: (singlePO && singlePO.potext) ? singlePO.potext : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
          reason: new FormControl({ value: (singlePO && singlePO.reason) ? singlePO.reason : '', disabled: this.user && (this.user.isOperative || this.user.isClient) ? true : false }),
        }))
      })
      return poListdata;
    } else {
      return [this.formBuilder.group({
        potext: new FormControl(''),
        reason: new FormControl(''),
      })]
    }
  }


  disablePOnumber(POnumbers) {
    // console.log("PONUMBERS TO CHANGES", POnumbers)
    let lastPOnumber = POnumbers[POnumbers.length - 1]
    // console.log("ELEMENT OF PO NUMBER FINDED", lastPOnumber)
    if (lastPOnumber.potext !== '') this.isdisablePOnum = false
    else this.isdisablePOnum = true
  }

  addMultiplePOnumber() {
    const control = <FormArray>this.labourjobForm.controls.ponumber
    control.push(this.formBuilder.group({
      potext: new FormControl(''),
      reason: new FormControl(''),
    }))
  }

  deletePOnumber(index) {
    const control = <FormArray>this.labourjobForm.controls.ponumber
    control.removeAt(index)
  }

  //  UTILITY

  emptyFrequencyDates() {
    console.log("VALUE OF CURRENT FORM", this.labourjobForm.value)
    const control = this.multipleOperativeGroup.value
    const formControl = this.multipleOperativeGroup
    const controlLength = control.length
    for (let i = 0; i < controlLength; i++) {
      const controlValue = control[i]
      if ((controlValue.frequencyDates && controlValue.frequencyDates.length) || (controlValue.frequencyDays && controlValue.frequencyDays.length)) {
        console.log("THIS IS THE EXISTING DATA", controlValue, control, formControl)
        formControl.at(i).patchValue({ frequencyDates: [], frequencyDays: [] })
      }
    }
    this.calculatePlannedhours()
  }



  async calculateAmount(list) {
    // if (this.singleJobDate && this.singleJobDate.length) {
    this.totalChargeRate = 0
    this.totalPayRate = 0
    if (this.totalTime == undefined) this.totalTime = await this.calculateTime(this.labourjobForm.controls.startTime.value, this.labourjobForm.controls.endTime.value, this.labourjobForm.controls.startDate.value)
    console.log("LIST OF ALL USERS ARE ADDED", this.totalTime, list)
    if (this.totalTime !== undefined) {
      let hours = this.totalTime.split(':')[0]
      let minutes = this.totalTime.split(':')[1]
      list.filter((x) => {
        x.frequencyDates.forEach((y) => {
          if (x.chargeRate && x.chargeRate != '') {
            this.totalChargeRate = this.totalChargeRate + (x.chargeRate * hours)
            if (minutes && minutes != 0) {
              let oneminAmount = (minutes * x.chargeRate) / 60
              this.totalChargeRate = this.totalChargeRate + oneminAmount
            }
          }
          if (x.payRate && x.payRate != '') {
            this.totalPayRate = this.totalPayRate + (x.payRate * hours)
            if (minutes && minutes != 0) {
              let oneminAmount = (minutes * x.payRate) / 60
              this.totalPayRate = this.totalPayRate + oneminAmount
            }
          }
        })
      })
      this.totalProfit = Number(this.totalChargeRate) - Number(this.totalPayRate)
      console.log("LIST OG ALL DATA", list, this.totalProfit, this.totalChargeRate)
    }
    const control = <FormArray>this.labourjobForm.controls.operatives
    let selectedComp = control.value
    let lastElement = selectedComp[selectedComp.length - 1]
    if (lastElement.competency != '') this.isComp = false
    else this.isComp = true
  }

  // Set current Location in form group
  setCurrentLocation(mapCurrentValue) {
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.labourjobForm.patchValue({
      coordinates: [this.longitude, this.latitude],
      jobLocation: this.address,
    })
    this.getAddressList().clear()
    this.updateAddressData(splitAddress)
    this.getWhat3words(this.latitude, this.longitude)
    console.log("FORM VALUE UPDATE", this.labourjobForm.value)
    this.updateOperativePlannedTime()
  }

  // Generate What3words for selected location
  getWhat3words(latitude, longitude) {
    what3words.api.convertTo3waGeoJson({ lat: latitude, lng: longitude }, 'en').then((words) => {
      this.what3words = { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words }
      this._cd.detectChanges()
      this.labourjobForm.patchValue({ what3words: { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words } })
    })
  }

  // Update the address details in array formate
  updateAddressData(address) {
    const control = this.getAddressList()
    address.forEach(element => {
      control.push(
        this.formBuilder.group({
          title: element
        })
      )
    });
  }

  addMultipleCompetency() {
    const control = <FormArray>this.labourjobForm.controls.operatives
    control.push(this.formBuilder.group({
      competency: new FormControl(''),
      competencyList: new FormControl(this.competencyList),
      operatives: new FormControl(''),
      chargeRate: new FormControl(''),
      payRate: new FormControl(''),
      averageFatigueScore: new FormControl(''),
      averageRiskScore: new FormControl(''),
      operativeList: new FormControl(''),
      frequencyDays: new FormControl([]),
      frequencyDates: new FormControl([]),
      plannedTravelTime: new FormControl('')
    }))
  }

  deleteCompetency(data, i) {
    console.log("INDEX OF COMPETENCY", i)
    const control = <FormArray>this.labourjobForm.controls.operatives
    control.removeAt(i)
    this.calculatePlannedhours()
  }


  // Change location using drag and drop and update location
  changeLocation(location, inputIndex) {
    let element = []
    element.push(this.getAddressList().value.map((x) => { return x.title }))
    const address = this.getAddressList().value
    let singleAddress = address.map((x) => { return x.title }).join(',')
  }

  // Change date-picker value and update in formgroup
  onChange(value, formControl) {
    if (formControl === 'startDate') {
      this.startingDate = value
      this.labourjobForm.patchValue({ startDate: value })
    }
    let endDateValue = this.labourjobForm.get('endDate').value
    if (formControl === 'startDate' && endDateValue) {
      let startDate = this.labourjobForm.get('startDate').value
      this.duration = this.calculateDuration(startDate, endDateValue)
    }
    if (formControl === 'endDate') {
      this.endingDate = value
      let startDate = this.labourjobForm.get('startDate').value
      this.duration = this.calculateDuration(startDate, value)
      this.labourjobForm.patchValue({ endDate: value })
    }
    this.emptyFrequencyDates()
    // this.jobDateComp.enableCheckBoxes();
  }

  // Calculation of duration 
  calculateDuration(startDate, endDate) {
    let date1: any = new Date(startDate);
    let date2: any = new Date(endDate);
    let diffTime = Math.abs(date2 - date1);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1
  }

  // Selected day wise date array 
  daySelection(obj, index) {
    console.log("SINGLE OBJECT DATA", obj)
    console.log("THERE IS THE SELECTED ITEM", index)
    const control = <FormArray>this.labourjobForm.controls.operatives
    let singleJobDates = obj.singleJobDates
    // this.singleJobDate = obj.singleJobDates;
    let arrayLength = singleJobDates.length;
    for (let i = 0; i < arrayLength; i++) {
      let date = new Date(singleJobDates[i].date)
      singleJobDates[i].date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      singleJobDates[i].totalhours = this.totalTime
    }
    console.log("THIS IS THE TOTAL DATE LIST FOR ONE USER", singleJobDates)
    control.at(index).patchValue({ frequencyDates: singleJobDates, frequencyDays: obj.totalDays })
    // this.totalDays = obj.totalDays;
    if (this.totalTime != undefined) this.calculatePlannedhours()
    if (this.totalChargeRate != 0 || this.totalPayRate != 0) this.calculateAmount(this.multipleOperativeGroup.value)
    // console.log("SINGLE JOB DATE LIST", this.singleJobDate);

    this._cd.detectChanges()
    console.log("LABOUR JOB VALUE", this.labourjobForm.value)
  }

  calculatePlannedhours() {
    // console.log("TOTAL HOURS WORKED DATA", this.totalHoursWorked)
    if (this.totalHoursWorked == undefined) this.totalHoursWorked = { hours: 0, minutes: 0 }
    let totalH = 0;
    let totalM = 0;
    console.log("OPERATIVE USERS DATA", this.multipleOperativeGroup.value)
    const operativeList = this.multipleOperativeGroup.value
    const tempLength = operativeList.length
    for (let i = 0; i < tempLength; i++) {
      _.forEach(operativeList[i].frequencyDates, (day, index) => {
        let hours = day.totalhours.split(':')
        totalH = totalH + Number(hours[0]);
        totalM = totalM + Number(hours[1]);
      })
    }
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
    } else if (totalM == 60) {
      this.totalHoursWorked.hours = totalH + 1;
      this.totalHoursWorked.minutes = totalM - 60
    }
    else {
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
    }
    this.displayHours = this.totalHoursWorked.hours + ":" + this.totalHoursWorked.minutes
  }


  // Filter on competency list
  filteronCompetency() {
    // let comList = config.list
    let comList
    let finalList = []

    this._competencyService.getCompetencyList().subscribe((data) => {
      comList = data
      comList.map(ele => {
        if (ele.value) ele.value.map(e => {
          finalList.push({ title: e.name, category: ele.viewValue, alias: e.alias })
        })
      })
      this.competencyList = finalList
      this.competencyListCopy = finalList
    })
  }

  // Search on competency title and alias
  competencyFilter(searchText, index) {
    const control = <FormArray>this.labourjobForm.controls.operatives
    // console.log("VALUE OF SPECIFIC INEDX", control.at(index).value);
    let existingCompeteny = control.at(index).value.competency
    this.competencyList = this.competencyListCopy
    let finalList = []
    if (searchText === '') {
      let staticList = this.competencyListCopy
      if (existingCompeteny && existingCompeteny.length) {
        for (let i = 0; i < existingCompeteny.length; i++) {
          let index = staticList.findIndex((x) => (x.title === existingCompeteny[i].title) && (x.alias === existingCompeteny[i].alias))
          console.log("THIS IS INDEX", index);
          staticList.splice(index, 1)
        }
        console.log("AFTER STATIC LIST REMOVED COMPETENCY", staticList);

        finalList = [...existingCompeteny, ...staticList]
      } else {
        finalList = staticList
      }
      control.at(index).patchValue({ competencyList: finalList })
      return;
    }
    let data = this.competencyList
    let tempDataSource = this._filter.filter1(searchText, data, ['title', 'alias']);
    if (existingCompeteny && existingCompeteny.length) finalList = [...existingCompeteny, ...tempDataSource]
    else finalList = tempDataSource
    control.at(index).patchValue({ competencyList: finalList })
  }


  multipleCompetencySelect(event, item, index) {
    let existingUsers = []
    let competencyList = event.value
    let existingCompeteny = this.labourjobForm.controls['operatives'].value.filter((x, currentIndex) => {
      console.log("THIS IS THE CURRENT INDEX AND MAIN INDEX", currentIndex, index)
      if (currentIndex !== index) {
        let temp = x.competency.filter((y) => competencyList.find((z) => z.alias == y.alias))
        if (temp && temp.length) return x
      }
    })
    let currentControl = <FormArray>this.labourjobForm.controls.operatives
    console.log("THIS IS EXISTING COMPETENCY LIST", existingCompeteny, currentControl.at(index), competencyList);
    if (existingCompeteny && existingCompeteny.length) {
      existingCompeteny.filter((x) => {
        if (x.operatives != '') existingUsers.push(x.operatives)
      })
    }
    let list = []
    let userLength = this.staffUserListCopy.length
    for (let i = 0; i < userLength; i++) {
      let x = this.staffUserListCopy[i]
      let userComp = []
      for (let j = 0; j < competencyList.length; j++) {
        let existComp = x.competencies.find((z) => z.alias == competencyList[j].alias)
        if (existComp != undefined) userComp.push(competencyList[j])
      }
      console.log("VALUE OF USER COMPONENT TO BE DISPLAY", userComp)
      if ((userComp && userComp.length) == (competencyList && competencyList.length) && (competencyList && competencyList.length !== 0)) {
        list.push(x)
      }
    }
    console.log("COMPETENCY LIST TO BE CHECKED", existingUsers, list);
    let finalUserList = []
    if (this.isEdit) {
      finalUserList = list
    } else {
      finalUserList = list.filter(function (obj) { return existingUsers.indexOf(obj) == -1; });
    }
    console.log("THIS IS FINAL USER LIST TO BE DISPLAY", finalUserList, existingUsers, list);
    const control = <FormArray>this.labourjobForm.controls.operatives
    control.at(index).patchValue({ operativeList: finalUserList })
    if (competencyList && competencyList.length === 0) {
      control.at(index).patchValue({ operatives: '' })
    }
    console.log("THIS IS THE FORM DATA TO BE DISPLAY", this.labourjobForm.value);
  }



  async selectOperative(item, index) {
    console.log("THIS IS THE SINGLE ITEM", item.value)
    console.log("INDEX OF SELECTED OPERATIVE", index)
    const tempData = this.jobList.filter((x) => x._id === item.value.operatives._id)
    console.log("OPERATIVE DATA FIND FROM PREVIOUS JOBS", tempData)
    const control = <FormArray>this.labourjobForm.controls.operatives
    if (tempData && tempData.length) this.existingUserData = tempData
    if ((item.value.frequencyDates && item.value.frequencyDates.length) || (item.value.frequencyDays && item.value.frequencyDays.length)) {
      control.at(index).patchValue({ frequencyDates: [], frequencyDays: [] })
    }
    const operativeAddress = (item.value.operatives && item.value.operatives.locationDetails) ? item.value.operatives.locationDetails._id.locationGeometry.coordinates : []
    const jobAddress = this.labourjobForm.controls.coordinates.value
    console.log("THIS IS THE JOB ADDRESS COORDINATED", jobAddress, operativeAddress, this.latitude, this.longitude)
    const travelTime: any = await this._mapService.getDistance(operativeAddress, jobAddress)
    if (travelTime.rows && travelTime.rows.length && travelTime.rows[0].elements[0].status === 'OK') {
      console.log("TRAVEL TIME BASED ON LOCATION", travelTime)
      let plannedTime = travelTime.rows[0].elements[0].duration.text.split(' ')
      console.log("THIS IS THE PLANNED TIME TO BE DISPLAY", plannedTime, plannedTime[0] + ':' + plannedTime[2])
      let hours
      let minutes
      for (let i = 0; i < plannedTime.length; i++) {
        if (plannedTime[0 + 1] === 'hours' || plannedTime[0 + 1] === 'hour') {
          hours = this.addPaddingValue(plannedTime[0], 2)
          minutes = this.addPaddingValue(plannedTime[2], 2)
        }
        if (plannedTime[0 + 1] === 'mins' || plannedTime[0 + 1] === 'min') {
          hours = '00'
          minutes = this.addPaddingValue(plannedTime[0], 2)
        }
      }
      console.log("FINAL MINUTES AND HOURS OF USER", hours, minutes)
      control.at(index).patchValue({ plannedTravelTime: hours + ':' + minutes })
    } else {
      control.at(index).patchValue({ plannedTravelTime: '' })
    }
  }


  async updateOperativePlannedTime() {
    let formData = this.labourjobForm.value
    console.log("AFTER JOB LOCATION IS CHANGED", formData)
    const operativeList = formData.operatives
    const operativeLength = formData.operatives.length
    const control = <FormArray>this.labourjobForm.controls.operatives
    for (let i = 0; i < operativeLength; i++) {
      if (operativeList[i].operatives && operativeList[i].operatives !== '') {
        const singleOperative = this.staffUserList.find((x) => x._id === operativeList[i].operatives._id)
        let operativeAddress
        console.log("SINGLE OPERATIVE DATA", singleOperative)
        if (singleOperative && singleOperative !== undefined) {
          operativeAddress = (singleOperative && singleOperative.locationDetails) ? singleOperative.locationDetails._id.locationGeometry.coordinates : []
        }
        // const operativeAddress = (operativeList[i].operatives && operativeList[i].operatives.locationDetails) ? operativeList[i].operatives.locationDetails._id.locationGeometry.coordinates : []
        console.log("THIS IS FOR OPERATIVE UPDATE", operativeList[i])
        const jobAddress = this.labourjobForm.controls.coordinates.value
        console.log("THIS IS THE JOB ADDRESS COORDINATED", jobAddress, operativeAddress, this.latitude, this.longitude)
        const travelTime: any = await this._mapService.getDistance(operativeAddress, jobAddress)
        if (travelTime.rows && travelTime.rows.length && travelTime.rows[0].elements[0].status === 'OK') {
          console.log("TRAVEL TIME BASED ON LOCATION", travelTime)
          let plannedTime = travelTime.rows[0].elements[0].duration.text.split(' ')
          console.log("THIS IS THE PLANNED TIME TO BE DISPLAY", plannedTime, plannedTime[0] + ':' + plannedTime[2])
          let hours
          let minutes
          for (let i = 0; i < plannedTime.length; i++) {
            if (plannedTime[0 + 1] === 'hours' || plannedTime[0 + 1] === 'hour') {
              hours = this.addPaddingValue(plannedTime[0], 2)
              minutes = this.addPaddingValue(plannedTime[2], 2)
            }
            if (plannedTime[0 + 1] === 'mins' || plannedTime[0 + 1] === 'min') {
              hours = '00'
              minutes = this.addPaddingValue(plannedTime[0], 2)
            }
          }
          console.log("FINAL MINUTES AND HOURS OF USER", hours, minutes)
          control.at(i).patchValue({ plannedTravelTime: hours + ':' + minutes })
        } else {
          control.at(i).patchValue({ plannedTravelTime: '' })
        }
      }
    }
  }

  addPaddingValue(num, numZeros) {
    // console.log("h is calling or not", h);
    let n = Math.abs(num);
    // console.log("what is the n value", n);

    let zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
    // console.log("what is the zero value", zeros);

    let zeroString = Math.pow(10, zeros).toString().substr(1);
    // console.log("what is the value of zero strinf", zeroString);

    if (num < 0) {
      zeroString = '-' + zeroString;
    }

    return zeroString + n;
  }


  competenylistedit(data, index) {
    console.log("THIS IS THE DATA", data);
    let existingCompeteny = data.competency
    let finalList = []
    let staticList = this.competencyList.slice(0)
    if (existingCompeteny && existingCompeteny.length) {
      for (let i = 0; i < existingCompeteny.length; i++) {
        let index = staticList.findIndex((x) => (x.title === existingCompeteny[i].title) && (x.alias === existingCompeteny[i].alias))
        console.log("THIS IS INDEX", index);
        staticList.splice(index, 1)
      }
      console.log("AFTER STATIC LIST REMOVED COMPETENCY", staticList);
      finalList = [...existingCompeteny, ...staticList]
    } else {
      finalList = staticList
    }
    return finalList
  }

  openCompetencySelect(index) {

    // console.log("WHEN MAT SELECT OPEN", index , this.competencyList);
    // console.log("THIs is another list", this.competencyListCopy);

    this.searchText = ''
    const control = <FormArray>this.labourjobForm.controls.operatives
    // console.log("VALUE OF SPECIFIC INEDX", control.at(index).value);
    let existingCompeteny = control.at(index).value.competency
    let finalList = []
    let staticList = this.competencyList.slice(0)
    if (existingCompeteny && existingCompeteny.length) {
      for (let i = 0; i < existingCompeteny.length; i++) {
        let index = staticList.findIndex((x) => (x.title === existingCompeteny[i].title) && (x.alias === existingCompeteny[i].alias))
        // console.log("THIS IS INDEX", index);              
        staticList.splice(index, 1)
      }
      console.log("AFTER STATIC LIST REMOVED COMPETENCY", staticList);
      finalList = [...existingCompeteny, ...staticList]
    } else {
      finalList = staticList
    }
    control.at(index).patchValue({ competencyList: finalList })
    return
  }


  compareObjects(o1: any, o2: any): boolean {
    return o1.alias === o2.alias;
  }

  compareObjects1(o1: any, o2: any): boolean {
    return o1._id === o2._id;
  }


  compareClientObjects(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  resetLabourjob() {
    this.jobDateComp.checkEnable = true;
    this.jobDateComp.clearCheckBoxes();
    this.labourjobForm.reset();
  }



  verifyUsersList() {
    this.staffUserListCopy = this.staffUserList
    let currentJobValue = this.labourjobForm.value
    // console.log("WHAT IS THE JOB LIST DATA", this.jobList);
    if (this.jobList && this.jobList.length) {
      this.staffUserListCopy = this.staffUserListCopy.filter((x) => {
        let existingUser = this.jobList.find((z) => z._id == x._id)
        if (existingUser != undefined) {
          // console.log("CALCULATE FOR EXISTING USERS", x, existingUser, currentJobValue);
          let currentStartDate = currentJobValue.startDate
          let currentEndDate = currentJobValue.endDate
          let existingStartDate = existingUser.startDate
          let existingEndDate = existingUser.endDate
          let isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          let isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          if (isStart && isEnd) {
            x['isSelected'] = true
            return x
          } else if (!isStart && !isEnd) {
            x['isSelected'] = false
            return x
          } else if (isStart && !isEnd) {
            if (currentStartDate == existingEndDate) {
              x['isSelected'] = this.calculateDiff(currentJobValue, existingUser)
            } else {
              x['isSelected'] = true
            }
            return x
          } else if (!isStart && isEnd) {
            if (currentEndDate == existingStartDate) {
              console.log("CALL THIS CONDITION OR NOT");

              x['isSelected'] = this.calculateEndDiff(currentJobValue, existingUser)
            } else {
              x['isSelected'] = true
            }
            return x
          }
        } else {
          // console.log("THIS IS WITHOUT JOB USER", x);
          x['isSelected'] = false
          return x
        }
      })
    }
  }


  calculateDiff(currentJobValue, existingJobValue) {
    console.log("CURRENT JOB VALUE", currentJobValue, existingJobValue);
    const currentDate = new Date(currentJobValue.startDate).setHours(currentJobValue.startTime.split(':')[0], currentJobValue.startTime.split(':')[1])
    const preDate = new Date(existingJobValue.endDate).setHours(existingJobValue.endTime.split(':')[0], existingJobValue.endTime.split(':')[1])
    const diff = (currentDate - preDate) / ((1000 * 60 * 60))
    console.log("WHAT IS THE DIFF", diff);
    if (diff > 12) {
      return false
    } else {
      return true
    }
  }

  calculateEndDiff(currentJobValue, existingJobValue) {
    console.log("CURRENT JOB VALUE", currentJobValue, existingJobValue);
    const currentDate = new Date(currentJobValue.endDate).setHours(currentJobValue.startTime.split(':')[0], currentJobValue.startTime.split(':')[1])
    const preDate = new Date(existingJobValue.startDate).setHours(existingJobValue.endTime.split(':')[0], existingJobValue.endTime.split(':')[1])
    const diff = (currentDate - preDate) / ((1000 * 60 * 60))
    console.log("WHAT IS THE DIFF", diff);
    if (diff > 12) {
      return false
    } else {
      return true
    }
  }

  checkDate(fromDate, toDate, checkDate) {
    let dateFrom = fromDate
    let dateTo = toDate
    let dateCheck = checkDate
    let d1 = dateFrom.split("/");
    let d2 = dateTo.split("/");
    let c = dateCheck.split("/");
    let from = new Date(d1);  // -1 because months are from 0 to 11
    let to = new Date(d2);
    let check = new Date(c);
    const checkFlag = check <= from && check >= to
    return check >= from && check <= to
  }


  verifyFrequencyDates(data) {
    if (data.operatives && data.operatives.length) {
      const tempLength = data.operatives.length
      for (let i = 0; i < tempLength; i++) {
        let tempData = data.operatives[i]
        if (tempData.frequencyDates && !tempData.frequencyDates.length) {
          tempData['operatives'] = ''
          tempData['frequencyDays'] = []
          tempData['chargeRate'] = 0
          tempData['payRate'] = 0
          tempData['plannedTravelTime'] = '00:00'
        }
      }
    }
    console.log("THIS IS THE  DATA TO BE SEND TO DATABASE", data)
    return data
  }

  // API CALL

  // ADD AND EDIT LABOUR JOB IN DATABASE 

  addLabourJob() {
    if (this.labourjobForm.valid) {
      this.loading = true
      this.labourjobForm.value['totalDays'] = this.totalDays
      this.labourjobForm.value['singleJobDate'] = this.singleJobDate
      this.labourjobForm.value['plannedhours'] = this.totalHoursWorked
      let addformdata = this.verifyFrequencyDates(this.labourjobForm.value);
      if (this.isEdit) this.editLabourjob(addformdata)
      else this.createLabourjob(addformdata)
    } else {
      this.labourjobForm.markAllAsTouched()
      this.isSubmit = true
    }
  }

  // API CALL FOR EDIT JOB

  editLabourjob(data) {
    console.log("SINGLE JOB DETAILS", this.singleJobDetail)
    console.log("JOB EDIT DATA TO BE PRINT", data)
    if (this.singleJobDetail && this.singleJobDetail.jobLocation) {
      data['locationId'] = this.singleJobDetail.jobLocation._id._id
    }
    this._labourjobService.editLabourjob(data, this.singleJobDetail._id).subscribe((res) => {
      console.log("WHAT IS THE RESPONSE OF DATA", res)
      this._utilityService.handleSnackBar({ msg: "Job edited successfully!", button: "Ok" })
      this.createForm(res)
      // this._router.navigate(['/labour-job/view/' + this.singleJobDetail._id], { queryParams: { currentTab: 1 } })
      this.loading = false
    }, err => {
      this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
      this.loading = false
    })
  }

  // API CALL FOR CREATE JOB

  createLabourjob(data) {
    this._labourjobService.createLabourjob(data).subscribe((res) => {
      this.loading = false
      this._utilityService.handleSnackBar({ msg: "Job added successfully!", button: "Ok" })
      this._router.navigate(['/labour-job/view/' + res._id])
    }, err => {
      this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
      this.loading = false
    })
  }

  // API CALL FOR DELETE JOB

  deleteLabourjob() {
    let deletejob = [this.singleJobDetail._id]
    let obj = { jobs: deletejob }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, 'job')
      .afterClosed().subscribe((data) => {
        if (data == '') return
        else if (data == 'yes') {
          this._labourjobService.deleteLabourjob(JSON.stringify(obj)).subscribe((deletedJob) => {
            this._utilityService.handleSnackBar({ msg: "Job deleted successfully!", button: "Ok" })
            this._router.navigate(['/multi-job-list'], { queryParams: { currentTab: 1 } })
          }, err => {
            console.log("Error while delete job", err);
          })
        } else return
      })
  }

  // Get list of operative users



  // Download job details with or without payment details
  downloadjobDetails(flag) {
    console.log("TYPE OF DOWNLOAD", flag);
    this.isDownload = true
    this._utilityService.handleSnackBar({ msg: 'Download will begin automatically', button: 'OK' })
    let obj = {
      isPayment: flag,
      jobId: this.singleJobDetail._id,
      totalChargeRate: this.totalChargeRate,
      totalPayRate: this.totalPayRate,
      totalProfit: this.totalProfit
    }
    this._labourjobService.generateJobPrint(obj).subscribe((pdfData) => {
      console.log("THIS IS THE PDF DATA TO BE DOWNLOAD", pdfData);
      const byteArray = new Uint8Array(pdfData.bufferData.data);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, this.singleJobDetail.jobTitle);
      this._utilityService.handleSnackBar({ msg: 'Download Successfully', button: 'OK' })
      this.isDownload = false
    }, err => {
      console.log("ERROR WHILE DOWNLOAD JOB PDF");
      this.isDownload = false
    })
  }

  getClientList() {
    this._clientService.getClients().subscribe((clients) => {
      console.log("THIS IS THE CLIENT LIST TO BE DISPLAY", clients);
      this.clientList = clients
    }, error => {

    })
  }


  getRequiredjobData() {
    this._labourjobService.getRequiredjobData('test2').subscribe((data) => {
      console.log("DATA OF ALL REQUIRED JOB", data)
      this.clientList = data.clients
      this.jobList = data.jobs
      this.allJobs = data.allJobs
      this.staffUserList = data.staff
      this.staffUserListCopy = data.staff
      this.assetCategoryList = data.assetList
      console.log("OTHER REQUIRED DATA FOR CREATE AND EDIT JOB", this.isEdit)
    }, error => {
      console.log("ERROR WHILE GET DATA", error);

    })
  }

}
